import {loadComics as loadData} from '../../services/api/comics';
import {getCurrentLocale} from '../../utils/i18n';

export const LOAD_COMICS_START = 'LOAD_COMICS_START';
export const LOAD_COMICS_ERROR = 'LOAD_COMICS_ERROR';
export const LOAD_COMICS_COMPLETE = 'LOAD_COMICS_COMPLETE';
export const COMICS_CHAPTER_READING_PROGRESS =
    'COMICS_CHAPTER_READING_PROGRESS';
export const COMICS_TUTORIAL_CLOSE = 'COMICS_TUTORIAL_CLOSE';

export const loadComics = () => async (dispatch, getState) => {
    dispatch({type: LOAD_COMICS_START});

    try {
        let locale = getCurrentLocale();
        let comics = await loadData(locale === 'por' ? 'por' : 'spa');
        dispatch({type: LOAD_COMICS_COMPLETE, comics});
    } catch (error) {
        dispatch({type: LOAD_COMICS_ERROR, error});
    }
};

export const updateProgress = (chapterId, progress) => dispatch => {
    dispatch({type: COMICS_CHAPTER_READING_PROGRESS, progress, chapterId});
};

export const comicTutorialClose = () => dispatch => {
    dispatch({type: COMICS_TUTORIAL_CLOSE});
};
